export default {"src":"/_next/static/media/waterfront.ccd6e194.svg","height":37,"width":31,"blurWidth":0,"blurHeight":0};